import { authenticatedFetch } from './base'

/**
 * Get patient's charts data for the case
 *
 * @param {number} circleId - circle ID
 * @param {number} caseId - case ID
 * @param {number} protocolId - protocol ID
 * @param {number} languageId - language ID
 * @returns {*} - response containing patient's charts data
 */
export const fetchInitialChart = (circleId, caseId, protocolId, languageId) => {
	return authenticatedFetch(
		`/api/responseRate/circle/${circleId}/case/${caseId}/protocol/${protocolId}/language/${languageId}`,
		{
			method: 'get'
		}
	)
		.then(function(response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function(cases) {
			return cases
		})
}

/**
 * Mark score as viewed to remove the "New" indication
 *
 * @param {number} patientId - patient ID
 * @param {number} caseId - case ID
 * @param {number} scoringGroupId - scoring group ID
 * @returns {*} - response indicating if the action was successful
 */
export const markScoresAsRead = (patientId, caseId, scoringGroupId) => {
	return authenticatedFetch(
		`/api/responseRate/markAsRead/${patientId}/${caseId}/${scoringGroupId}`,
		{
			method: 'put'
		}
	)
		.then(function (response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function (cases) {
			return cases
		})
}